export const similarCaseData = {
  title: 'It looks like you already have an appointment for this issue',
  standFirst:
    'Feel free to share any extra information during your upcoming appointment. If you need more help, you can always schedule a follow-up appointment after talking with one of our experts.',
  imgObj: {
    alt: 'A person holding a mobile phone',
    src: 'https://media.product.which.co.uk/prod/images/original/b06060da427e-flight-delay-step-10.jpg',
  },
}
